import { Component } from '@angular/core';
@Component({
  template: `
    <div
      style="width: 100%; height: 100%; background: white; overflow: hidden; flex-direction: column; justify-content: center; align-items: center; gap: 32px; display: inline-flex"
    >
      <img style="width: 450px; height: 300.39px;" src="assets/images/icon_unauthorized.png" />
      <div
        style="text-box-trim: trim-both; text-box-edge: cap alphabetic; justify-content: center; display: flex; flex-direction: column; color: var(--Dynamic-PMC-global-color-error, #B41853); font-size: 36px; font-family: Open Sans; font-weight: 700; text-transform: capitalize; line-height: 18px; word-wrap: break-word"
      >
        ACCESS RESTRICTED
      </div>
      <div
        style="text-box-trim: trim-both; text-box-edge: cap alphabetic; text-align: center; justify-content: center; display: flex; flex-direction: column; color: var(--Static-Neutral-global-color-neutral-dark, #3C3C3B); font-size: 24px; font-family: Open Sans; font-weight: 400; line-height: 32px; word-wrap: break-word; margin-bottom:80px"
      >
        Seems like you don't have permission to view it.<br />Contact your admin to request access.
      </div>
    </div>
  `
})
export class Unauthorized {}
